import { render, staticRenderFns } from "./reservation-dashboard-card.vue?vue&type=template&id=1ba3f8ce&scoped=true&"
import script from "./reservation-dashboard-card.vue?vue&type=script&lang=js&"
export * from "./reservation-dashboard-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3f8ce",
  null
  
)

export default component.exports